import React, { memo } from 'react';

const Surveys = () => {
  return <></>;
};

export default memo(Surveys);
